/* src/app/core/modules/shared/components/modal-search/modal-search.component.scss */
ion-content {
  --ion-item-background: transparent;
  --ion-item-color: var(--ion-color-light, #fff);
}
/*# sourceMappingURL=/avvera/dev/modal-search.component.css.map */
